import React from "react";
import { Button } from "../ui/button";
import { useToast } from "../ui/use-toast";

export function IntegrationsSettings() {
  const { toast } = useToast();

  const handleConnect = (service: string) => {
    toast({
      title: "Coming Soon",
      description: `Integration with ${service} will be available soon.`,
    });
  };

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold mb-4">Integrations</h2>
        <p className="text-muted-foreground">
          Connect your favorite note-taking apps to sync your meeting notes.
        </p>
      </div>

      <div className="grid gap-6">
        <div className="flex items-center justify-between p-4 border rounded-lg">
          <div>
            <h3 className="font-semibold">Notion</h3>
            <p className="text-sm text-muted-foreground">
              Sync your meeting notes with Notion
            </p>
          </div>
          <Button onClick={() => handleConnect("Notion")}>Connect</Button>
        </div>

        <div className="flex items-center justify-between p-4 border rounded-lg">
          <div>
            <h3 className="font-semibold">Evernote</h3>
            <p className="text-sm text-muted-foreground">
              Sync your meeting notes with Evernote
            </p>
          </div>
          <Button onClick={() => handleConnect("Evernote")}>Connect</Button>
        </div>

        <div className="flex items-center justify-between p-4 border rounded-lg">
          <div>
            <h3 className="font-semibold">OneNote</h3>
            <p className="text-sm text-muted-foreground">
              Sync your meeting notes with OneNote
            </p>
          </div>
          <Button onClick={() => handleConnect("OneNote")}>Connect</Button>
        </div>
      </div>
    </div>
  );
}